export default "__VITE_ASSET__B6rshxiX__"